module.exports = __webpack_public_path__ + "static/media/handshake-alt.cc8cccf4.svg";